var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartTruckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.495,
    height: 14.286,
    viewBox: "0 0 24.495 14.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "truck-svgrepo-com",
    d: "M22.929,103.05c-.077-.016-.15-.031-.214-.048-.732-.19-1.066-.295-1.313-.772l-.936-1.894a2.141,2.141,0,0,0-1.731-1.053H17.07V97.1a.713.713,0,0,0-.712-.712l-11.6.012a.674.674,0,0,0-.671.707v.647H1.113a1.113,1.113,0,0,0,0,2.226H4.085v1.067H2.139a1.113,1.113,0,1,0,0,2.226H4.085v1.067h-.92a1.113,1.113,0,1,0,0,2.226h.92v1.116a.713.713,0,0,0,.712.712H6a2.668,2.668,0,0,0,5.279,0h4.884c.025,0,.051,0,.077,0a2.668,2.668,0,0,0,5.279,0h1.733a1.239,1.239,0,0,0,1.238-1.237v-2.1C24.495,103.379,23.553,103.181,22.929,103.05Zm-4.045,3.982a.97.97,0,1,1-.97.97A.971.971,0,0,1,18.884,107.033ZM17.07,102.9v-2.583h1.273a1.655,1.655,0,0,1,1.317.8l.833,1.686q.026.051.055.1H17.07ZM9.614,108a.97.97,0,1,1-.97-.97A.971.971,0,0,1,9.614,108Z",
    transform: "translate(0 -96.384)",
    fill: "#29235c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartTruckIcon);
export default __webpack_public_path__ + "static/media/chart-truck-icon.bca6b566.svg";
export { ForwardRef as ReactComponent };